<template>
  <v-hover v-slot="{ hover }" close-delay="200">
    <div ref="container" style="display: flex; flex-grow: 1;">
      <v-textarea v-model="modelValue" :readonly="!externaledit && (IsDisabled || !edit)" class="q-input" ref="textarea"
        :class="[BorderClass, CompactClass, BlurrClass, InputColorClass]" :background-color="BackgroundColor"
        :label="labelText" :type="type ? type : undefined" rows="1" auto-grow hide-details="auto" :disabled="IsDisabled"
        :clearable="!IsEmpty && clearable" :single-line="singleline" :color="color" :rules="rules"
        :error="hasManualErrors" :error-messages="errormessages" :hoverbool="setHoverBool(hover)"
        :placeholder="placeholderText" persistent-placeholder flat @focus="setEdit" @blur="blurInput"
        @update:error="onErrorChange" @keydown.enter.exact="timestampOnFirstLineEnter ? newline($event) : null"
        @keypress="editKeyPress" @keydown="editKeyDown">

        <!-- PREPEND SLOTS -->
        <template v-slot:prepend>
          <slot name="prepend-outer" />
        </template>

        <template v-slot:prepend-inner>
          <slot name="prepend" />
        </template>
        <!------------------->

        <!-- APPEND SLOTS -->
        <template v-slot:append>
          <slot name="append">
            <v-progress-circular v-if="loading" indeterminate size="20" width="2" color="primary">
            </v-progress-circular>
            <LockedWarning v-else-if="disabled" :hover="hover" />
            <ExternalChangeWarning v-if="!allowexternaloverride && externallychanged"
              @Sync="(newValue = value, externallychanged = false)" />
          </slot>
        </template>

        <template v-slot:append-outer>
          <slot name="append-outer">
            <v-btn v-if="modelValue" icon style="position: absolute; z-index: 100; right: 0; top: 0;" x-small
              @click="copyText()">
              <v-icon :size="copyState ? 15 : 12" :color="copyState"
                v-text="copyState ? (copyState == 'success' ? 'mdi-check' : 'mdi-close') : 'mdi-content-copy'">
              </v-icon>
            </v-btn>
          </slot>
        </template>
        <!------------------->

      </v-textarea>
    </div>
  </v-hover>
</template>


<script>
import ExternalChangeWarning from "@/components/Inputs/Parts/ExternalChangeWarning.vue";
import LockedWarning from "@/components/Inputs/Parts/LockedWarning.vue";
import InputMixin from "@/helpers/Mixins/InputMixin";

export default {
  name: "QTextArea",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    value: [Object, String, Number, Array],
    list: Array,
    type: String,
    multiple: Boolean,
    color: String,
    backgroundcolor: String,
    singleline: Boolean,
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    emitOnlyOnBlur: Boolean,
    placeholder: [String, Object],
    rules: Array,
    errormessages: Array,
    allowexternaloverride: Boolean,
    timestampOnFirstLineEnter: Boolean
  },
  components: {
    LockedWarning,
    ExternalChangeWarning,
  },
  mixins: [InputMixin],

  data() {
    return {
      textareaWidth: undefined,
      error: false,
      edit: false,
      newValue: this.value,
      copyState: null,
    };
  },

  methods: {
    copyText() {
      navigator.clipboard.writeText(this.modelValue).then(() => {
        this.copyState = 'success';
        setTimeout(() => {
          this.copyState = null;
        }, 1000);
        //console.log('Content copied to clipboard');
      }, (e) => {
        this.copyState = 'error';
        setTimeout(() => {
          this.copyState = null;
        }, 500);
        console.error('Failed to copy', e);
      });
    },

    onErrorChange(e) {

      this.error = e;
      this.$emit("Error", e);
    },

    newline(e) {
      //console.log('e', e);
      const textarea = this.$refs.textarea.$refs.input;
      const existingtext = textarea.value;
      let cursorIndex = textarea.selectionStart ? textarea.selectionStart : 0;
      if (cursorIndex < 3) {
        e.preventDefault();
        var insertText = this.getUserTimestamp();
        this.newValue = insertText + existingtext;
        this.$nextTick().then(() => {
          textarea.selectionStart = cursorIndex + insertText.length;
          textarea.selectionEnd = cursorIndex + insertText.length;
        });
      }
    },
  },

  computed: {
    hasManualErrors() {
      var has = this.errormessages && (this.errormessages.length > 0)
      return has;
    },
  },

  watch: {},
};
</script>


<style scoped></style>
